// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"6nOQm":[function(require,module,exports) {
var _menuJs = require("./menu.js");
var _crossfadeImageJs = require("./crossfade-image.js");
var _detailsJs = require("./details.js");
var _modalJs = require("./modal.js");
var _tocJs = require("./toc.js");
var _feedback = require("./feedback");
var _cardVagasClick = require("./card-vagas-click");
var _focusInput = require("./focusInput");

},{"./menu.js":"bnMMg","./crossfade-image.js":"dWVid","./details.js":"5ktwd","./modal.js":"l1Y9d","./toc.js":"hqeh6","./feedback":"78qea","./card-vagas-click":"ctbhL","./focusInput":"c84kj"}],"bnMMg":[function(require,module,exports) {
const initMenu = ()=>{
    const menu = document.querySelector(".menu");
    const submenu = document.querySelectorAll(".menu-sitemap__sublist");
    const toggleButton = document.querySelector(".menu-toggle__button");
    const menuPopover = document.querySelectorAll("[data-menu-popover]");
    const focusableElements = menu.querySelectorAll("a, button, details");
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    /**
     * Handle hamburger menu.
     */ const closeMenu = ()=>{
        menu.dataset.menuDialog = "close";
        toggleButton.setAttribute("aria-expanded", false);
        toggleButton.focus();
        document.body.classList.remove("no-scroll");
    };
    const openMenu = ()=>{
        menu.dataset.menuDialog = "open";
        toggleButton.setAttribute("aria-expanded", true);
        document.body.classList.add("no-scroll");
    };
    const toggleMenu = ()=>{
        menu.dataset.menuDialog === "open" ? closeMenu() : openMenu();
    };
    const trapFocus = (event)=>{
        if (menu.dataset.menuDialog !== "open") return;
        if (event.key === "Tab") {
            if (event.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    event.preventDefault();
                }
            } else if (document.activeElement === lastFocusableElement) {
                firstFocusableElement.focus();
                event.preventDefault();
            }
        }
    };
    const handleKeydown = (event)=>{
        (event.key === "Escape" || event.keyCode === 27) && closeMenu();
    };
    toggleButton.addEventListener("click", toggleMenu);
    menu.addEventListener("keydown", trapFocus);
    menu.addEventListener("keydown", handleKeydown);
    /**
     * Handle submenu.
     * Close all submenus except the one clicked.
     */ const closeOtherSubmenus = (el)=>{
        submenu.forEach((item)=>item !== el && item.removeAttribute("open"));
    };
    submenu.forEach((targetItem)=>{
        targetItem.addEventListener("click", ()=>closeOtherSubmenus(targetItem));
    });
    /**
     * Handle Menu Popover.
     * Close when click outside of the submenu.
     */ const closemenuPopover = (el)=>{
        el.removeAttribute("open");
    };
    document.addEventListener("click", (event)=>{
        menuPopover.forEach((targetItem)=>{
            const isClickInside = targetItem.contains(event.target);
            !isClickInside && closemenuPopover(targetItem);
        });
    });
};
initMenu();

},{}],"dWVid":[function(require,module,exports) {
const images = document.querySelectorAll("[data-crossfade-image]");
const crossFadeImages = ()=>{
    let index = 0;
    if (images.length < 2) return;
    setInterval(()=>{
        images.forEach((image)=>image.setAttribute("data-crossfade-image", "hidden"));
        index += 1;
        index >= images.length && (index = 0);
        images[index].setAttribute("data-crossfade-image", "visible");
    }, 2000);
};
images.length && crossFadeImages();

},{}],"5ktwd":[function(require,module,exports) {
/**
 * Function that extends the native details element to close when clicking outside or pressing the ESC key.
 * Default behavior of the details element is just to close when clicking on the summary element.
 * To add this custom behavior, it is necessary the respective data attributes:
 *  data-details-close-on-click-outside
 *  data-details-close-on-esc
 */ const detailsToBeClosedOnClickOutside = document.querySelectorAll("[data-details-close-on-click-outside]");
const detailsToBeClosedWhenEscPressed = document.querySelectorAll("[data-details-close-on-esc");
const closeDetails = (el)=>{
    el.removeAttribute("open");
};
document.addEventListener("click", (event)=>{
    detailsToBeClosedOnClickOutside.forEach((targetItem)=>{
        const isClickInside = targetItem.contains(event.target);
        !isClickInside && closeDetails(targetItem);
    });
});
document.addEventListener("keydown", (event)=>{
    if (event.key === "Escape" || event.keyCode === 27) detailsToBeClosedWhenEscPressed.forEach((targetItem)=>closeDetails(targetItem));
});

},{}],"l1Y9d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _micromodal = require("micromodal");
var _micromodalDefault = parcelHelpers.interopDefault(_micromodal);
(0, _micromodalDefault.default).init({
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
});

},{"micromodal":"1FEvG","@parcel/transformer-js/src/esmodule-helpers.js":"ac90t"}],"1FEvG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function e(e, t) {
    for(var o = 0; o < t.length; o++){
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
}
function t(e) {
    return function(e) {
        if (Array.isArray(e)) return o(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function(e, t) {
        if (!e) return;
        if ("string" == typeof e) return o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
    }(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function o(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
    return n;
}
var n, i, a, r, s, l = (n = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])'
], i = function() {
    function o(e) {
        var n = e.targetModal, i = e.triggers, a = void 0 === i ? [] : i, r = e.onShow, s = void 0 === r ? function() {} : r, l = e.onClose, c = void 0 === l ? function() {} : l, d = e.openTrigger, u = void 0 === d ? "data-micromodal-trigger" : d, f = e.closeTrigger, h = void 0 === f ? "data-micromodal-close" : f, v = e.openClass, g = void 0 === v ? "is-open" : v, m = e.disableScroll, b = void 0 !== m && m, y = e.disableFocus, p = void 0 !== y && y, w = e.awaitCloseAnimation, E = void 0 !== w && w, k = e.awaitOpenAnimation, M = void 0 !== k && k, A = e.debugMode, C = void 0 !== A && A;
        !function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, o), this.modal = document.getElementById(n), this.config = {
            debugMode: C,
            disableScroll: b,
            openTrigger: u,
            closeTrigger: h,
            openClass: g,
            onShow: s,
            onClose: c,
            awaitCloseAnimation: E,
            awaitOpenAnimation: M,
            disableFocus: p
        }, a.length > 0 && this.registerTriggers.apply(this, t(a)), this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this);
    }
    var i, a, r;
    return i = o, a = [
        {
            key: "registerTriggers",
            value: function() {
                for(var e = this, t = arguments.length, o = new Array(t), n = 0; n < t; n++)o[n] = arguments[n];
                o.filter(Boolean).forEach(function(t) {
                    t.addEventListener("click", function(t) {
                        return e.showModal(t);
                    });
                });
            }
        },
        {
            key: "showModal",
            value: function() {
                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (this.activeElement = document.activeElement, this.modal.setAttribute("aria-hidden", "false"), this.modal.classList.add(this.config.openClass), this.scrollBehaviour("disable"), this.addEventListeners(), this.config.awaitOpenAnimation) {
                    var o = function t() {
                        e.modal.removeEventListener("animationend", t, !1), e.setFocusToFirstNode();
                    };
                    this.modal.addEventListener("animationend", o, !1);
                } else this.setFocusToFirstNode();
                this.config.onShow(this.modal, this.activeElement, t);
            }
        },
        {
            key: "closeModal",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = this.modal;
                if (this.modal.setAttribute("aria-hidden", "true"), this.removeEventListeners(), this.scrollBehaviour("enable"), this.activeElement && this.activeElement.focus && this.activeElement.focus(), this.config.onClose(this.modal, this.activeElement, e), this.config.awaitCloseAnimation) {
                    var o = this.config.openClass;
                    this.modal.addEventListener("animationend", function e() {
                        t.classList.remove(o), t.removeEventListener("animationend", e, !1);
                    }, !1);
                } else t.classList.remove(this.config.openClass);
            }
        },
        {
            key: "closeModalById",
            value: function(e) {
                this.modal = document.getElementById(e), this.modal && this.closeModal();
            }
        },
        {
            key: "scrollBehaviour",
            value: function(e) {
                if (this.config.disableScroll) {
                    var t = document.querySelector("body");
                    switch(e){
                        case "enable":
                            Object.assign(t.style, {
                                overflow: ""
                            });
                            break;
                        case "disable":
                            Object.assign(t.style, {
                                overflow: "hidden"
                            });
                    }
                }
            }
        },
        {
            key: "addEventListeners",
            value: function() {
                this.modal.addEventListener("touchstart", this.onClick), this.modal.addEventListener("click", this.onClick), document.addEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "removeEventListeners",
            value: function() {
                this.modal.removeEventListener("touchstart", this.onClick), this.modal.removeEventListener("click", this.onClick), document.removeEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "onClick",
            value: function(e) {
                (e.target.hasAttribute(this.config.closeTrigger) || e.target.parentNode.hasAttribute(this.config.closeTrigger)) && (e.preventDefault(), e.stopPropagation(), this.closeModal(e));
            }
        },
        {
            key: "onKeydown",
            value: function(e) {
                27 === e.keyCode && this.closeModal(e), 9 === e.keyCode && this.retainFocus(e);
            }
        },
        {
            key: "getFocusableNodes",
            value: function() {
                var e = this.modal.querySelectorAll(n);
                return Array.apply(void 0, t(e));
            }
        },
        {
            key: "setFocusToFirstNode",
            value: function() {
                var e = this;
                if (!this.config.disableFocus) {
                    var t = this.getFocusableNodes();
                    if (0 !== t.length) {
                        var o = t.filter(function(t) {
                            return !t.hasAttribute(e.config.closeTrigger);
                        });
                        o.length > 0 && o[0].focus(), 0 === o.length && t[0].focus();
                    }
                }
            }
        },
        {
            key: "retainFocus",
            value: function(e) {
                var t = this.getFocusableNodes();
                if (0 !== t.length) {
                    if (t = t.filter(function(e) {
                        return null !== e.offsetParent;
                    }), this.modal.contains(document.activeElement)) {
                        var o = t.indexOf(document.activeElement);
                        e.shiftKey && 0 === o && (t[t.length - 1].focus(), e.preventDefault()), !e.shiftKey && t.length > 0 && o === t.length - 1 && (t[0].focus(), e.preventDefault());
                    } else t[0].focus();
                }
            }
        }
    ], e(i.prototype, a), r && e(i, r), o;
}(), a = null, r = function(e) {
    if (!document.getElementById(e)) return console.warn("MicroModal: \u2757Seems like you have missed %c'".concat(e, "'"), "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="'.concat(e, '"></div>')), !1;
}, s = function(e, t) {
    if (function(e) {
        e.length <= 0 && (console.warn("MicroModal: \u2757Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>'));
    }(e), !t) return !0;
    for(var o in t)r(o);
    return !0;
}, {
    init: function(e) {
        var o = Object.assign({}, {
            openTrigger: "data-micromodal-trigger"
        }, e), n = t(document.querySelectorAll("[".concat(o.openTrigger, "]"))), r = function(e, t) {
            var o = [];
            return e.forEach(function(e) {
                var n = e.attributes[t].value;
                void 0 === o[n] && (o[n] = []), o[n].push(e);
            }), o;
        }(n, o.openTrigger);
        if (!0 !== o.debugMode || !1 !== s(n, r)) for(var l in r){
            var c = r[l];
            o.targetModal = l, o.triggers = t(c), a = new i(o);
        }
    },
    show: function(e, t) {
        var o = t || {};
        o.targetModal = e, !0 === o.debugMode && !1 === r(e) || (a && a.removeEventListeners(), (a = new i(o)).showModal());
    },
    close: function(e) {
        e ? a.closeModalById(e) : a.closeModal();
    }
});
"undefined" != typeof window && (window.MicroModal = l);
exports.default = l;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ac90t"}],"ac90t":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"hqeh6":[function(require,module,exports) {
const article = document.querySelector(".article");
if (article) {
    const articleHeadings = document.querySelectorAll(".article__content .rich-text h2");
    const articleHeadingsList = document.querySelector(".article__toc__list");
    if (articleHeadings.length < 2) return;
    articleHeadings.forEach((heading)=>{
        const headingText = heading.innerText;
        const headingId = heading.id;
        const headingItem = document.createElement("li");
        headingItem.classList.add("article__toc__item");
        const headingLink = document.createElement("a");
        headingLink.classList.add("article__toc__link");
        headingLink.setAttribute("href", `#${headingId}`);
        headingLink.innerText = headingText;
        headingItem.appendChild(headingLink);
        articleHeadingsList.appendChild(headingItem);
    });
    window.addEventListener("scroll", ()=>{
        const articleHeadingsArray = Array.from(articleHeadings);
        articleHeadingsArray.forEach((heading, index)=>{
            const headingId = heading.id;
            const headingItem = document.querySelector(`.article__toc__item a[href="#${headingId}"]`);
            const headingItemParent = headingItem.parentNode;
            if (heading.getBoundingClientRect().top < 100) {
                headingItemParent.classList.add("article__toc__item--active");
                const previousHeading = articleHeadingsArray[index - 1];
                if (previousHeading) {
                    const previousHeadingId = previousHeading.id;
                    const previousHeadingItem = document.querySelector(`.article__toc__item a[href="#${previousHeadingId}"]`);
                    const previousHeadingItemParent = previousHeadingItem.parentNode;
                    previousHeadingItemParent.classList.remove("article__toc__item--active");
                    previousHeadingItemParent.classList.add("article__toc__item--finished");
                }
            } else {
                headingItemParent.classList.remove("article__toc__item--active");
                if (heading.getBoundingClientRect().top > 100) headingItemParent.classList.remove("article__toc__item--finished");
            }
        });
    });
}

},{}],"78qea":[function(require,module,exports) {
/**
 * Sections that asks if the content was useful or not.
 * This script is used to show a message when the user clicks on one of the buttons.
 */ const contentFeedbackSection = document.querySelector(".content-feedback");
if (contentFeedbackSection) {
    const toggle = document.querySelector("[data-content-feedback-status]");
    const buttons = document.querySelectorAll("[data-content-feedback-button]");
    buttons.forEach((button)=>{
        button.addEventListener("click", ()=>toggle.setAttribute("data-content-feedback-status", "answered"));
    });
}

},{}],"ctbhL":[function(require,module,exports) {
const articles = document.querySelectorAll("article.vagas__card");
let isDragging = false;
function handleEvent(event, element) {
    const innerButtons = element.querySelectorAll(".button,.vagas__card__share"); // selecione o botão interno
    if (element.closest(".swiper-slide-active")) {
        if (event.type === "pointerup" && !isDragging || event.type === "keydown" && (event.keyCode === 13 || event.keyCode === 32 || event.code === "Enter" || event.code === "Space")) {
            if (element.dataset.permalink) {
                let clickInnerButton = false;
                innerButtons.forEach((innerButton)=>{
                    if (innerButton && innerButton.contains(event.target)) {
                        // verifique se o evento ocorreu no botão interno
                        isDragging = false;
                        clickInnerButton = true;
                    }
                });
                if (clickInnerButton) return; // interrompa o evento para evitar que o link seja aberto duas vezes
                const permalink = element.dataset.permalink;
                const newTab = window.open(permalink, "_blank");
                newTab.addEventListener("blur", ()=>{
                    element.focus();
                });
                element.setAttribute("aria-describedby", "link-aberto");
                isDragging = true;
                setTimeout(()=>{
                    element.removeAttribute("aria-describedby");
                    element.blur();
                }, 5000);
            }
            isDragging = false;
        } else if (event.type === "pointerdown") isDragging = false;
        else if (event.type === "pointermove") isDragging = true;
    }
}
// if (!/Mobile|Tablet/i.test(navigator.userAgent)) {}
articles.forEach((article, index)=>{
    article.setAttribute("tabindex", 0);
    article.setAttribute("role", "article");
    article.addEventListener("pointerup", (event)=>handleEvent(event, article));
    article.addEventListener("pointerdown", (event)=>handleEvent(event, article));
    article.addEventListener("pointermove", (event)=>handleEvent(event, article));
    article.addEventListener("keydown", (event)=>handleEvent(event, article));
    article.addEventListener("click", (event)=>{
        handleEvent(event, article);
        isDragging = false;
    });
});

},{}],"c84kj":[function(require,module,exports) {
const inputs = document.querySelectorAll(".search-bar__input");
inputs.forEach((element, key)=>{
    element.addEventListener("focusin", (event)=>{
        if (event.target.matches(":focus-visible") && event.relatedTarget !== null) {
            // Encontra o elemento pai usando a propriedade parentNode
            const parentElement = event.target.parentNode;
            parentElement.classList.add("focus-visible");
        }
    });
    element.addEventListener("focusout", (event)=>{
        // Encontra o elemento pai usando a propriedade parentNode
        const parentElement = event.target.parentNode;
        parentElement.classList.remove("focus-visible");
    });
});

},{}]},["6nOQm"], "6nOQm", "parcelRequire94c2")

//# sourceMappingURL=index.js.map
